import admin from '../../services/api/admin'
import {getAdminState} from "@/store/States";
import _ from "lodash";

function findUserByID(id, users) {
    for (let i = 0; i < users.length; i++) {
        if (users[i].userid === id)
            return i
    }
    return -1
}

const state = getAdminState()

const getters = {
    isLoading: state => mode => state.status[mode] === 'loading',
    isSuccess: state => mode => state.status[mode] === 'success',
}

const actions = {
    async updateUser({commit, rootState}, {id, key, val}) {
        commit('loading', 'update')

        let payload = {
            token: rootState.auth.user.token,
            userid: id,
        }

        payload[key] = val

        let response
        try {
            response = await admin.updateUser(payload)
        } catch (e) {
            return commit('error', 'update')
        }
        if (response.Success) {
            commit('setUserUpdate', {id, key, val})
            commit('success', 'update')
        } else {
            commit('error', 'update')
        }
    },

    async getUserIDs({commit, rootState, state, dispatch}) {
        commit('loading', 'load')

        let response
        try {
            response = await admin.getUserIDs(rootState.auth.user.token)
        } catch (e) {
            return commit('error', 'load')
        }

        if (response.Success) {
            let userIds = response.userid
            let addition = _.difference(userIds, state.userIds)
            let removal = _.difference(state.userIds, userIds)
            if (removal.length) {
                for (let i = 0; i < removal.length; i++) {
                    commit('removeUser', removal[i])
                }
            }
            if (addition.length) {
                let ids = {
                    ids: addition,
                    count: addition.length
                }
                commit('pushIDs', ids)
            }
            commit('success', 'load')
        } else {
            commit('error', 'load')
        }
    },
    async loadUsers({commit, state, rootState, dispatch}, {from, to}) {
        commit('loading', 'load')

        if (from === undefined) from = 0
        if (to === undefined) to = state.userIds.length

        const ids = state.userIds.slice(from, to)
        dispatch('thumbnails/getThumbnails', ids, { root: true })
        const payload = {
            token: rootState.auth.user.token,
            useridlist: '[' + ids.toString() + ']',
        }
        let response
        try {
            response = await admin.getUserStatByID(payload)
        } catch (e) {
            return commit('error', 'load')
        }

        if (response.Success) {
            // dispatch('thumbnails/findThumbs', {objList: response.Stats}, {root: true})
            commit('setUsers', {users: response.Stats.concat(), from, to})
            commit('success', 'load')
        } else {
            return commit('error', 'load')
        }
    }
}

const mutations = {
    setUserUpdate(state, data) {
        let i = findUserByID(data.id, state.users)
        state.users[i][data.key] = data.val
    },
    setUsers(state, data) {
        const users = data.users
        for (let i = data.from; i < state.users.length && i < data.to; i++) {
            let j = i - data.from
            if (users[j].photo)
                delete users[j].photo
            if (!users[j].auth)
                users[j]['auth'] = 'normal'
            if (state.users[i].userid === users[j].userid)
                Object.assign(state.users[i], users[j])
                state.users[i] = {...state.users[i], ...users[j]}
        }
    },
    removeUser(state, id) {
        const iId = state.userIds.indexOf(id)
        state.userIds.splice(iId, 1)
        const iUser = findUserByID(id, state.users)
        state.users.splice(iUser, 1)
        state.countUser--
    },
    pushIDs(state, ids) {
        state.countUser += ids.count
        state.userIds.splice(-1, 0, ...ids.ids)
        ids.ids.forEach(id => state.users.push({userid: id}))
    },
    resetState(state) {
        Object.assign(state, getAdminState())
    },
    loading(state, mode) {
        state.status[mode] = 'loading'
    },
    success(state, mode) {
        state.status[mode] = 'success'
    },
    error(state, mode) {
        state.status[mode] = 'error'
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
